import { useMemo } from 'react'

import { useFormatLanguage } from '../../../hooks/useFormatLanguage'
import { form } from '../../formState'
import { useTexts } from './hooks/useTexts'

const languages: uui.domain.Language[] = ['de', 'en', 'es', 'fr', 'it', 'nl', 'pt']

export function Language() {
  const formatLanguage = useFormatLanguage()
  const texts = useTexts()

  const options = useMemo(
    () =>
      languages.map(value => ({
        value,
        label: formatLanguage(value),
      })),
    [formatLanguage],
  )

  return (
    <form.SimpleSelect
      validateOn="blur change"
      options={options}
      testId="language"
      label={texts.language}
      name="language"
    />
  )
}
